const formatDateWithYear = (date) =>
  new Date(date).toLocaleString('default', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

export default formatDateWithYear
